import * as React from "react";
import { useEffect, useState } from "react";
import { Routes, Route, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthProvider } from "./component/auth/AuthContext";
import "./i18n";
import main from "./assets/images/boxOne.webp";

import HomeUser from "./pages/home";
import ExplainBuyPage from "./pages/explainBuyPage";
import CountShippingPage from "./pages/countShippingPage";
import ChooseCategoryTrukeyPage from "./pages/chooseCatgoryTrukeyPage";
import ChooseCategoryEroupaPage from "./pages/chooseCategoryEroupaPage";
import ChooseShoppingEroupaPage from "./pages/chooseShoppingEroupaPage";
import ChooseShoppingTrukeyPage from "./pages/chooseShoppingTrukeyPage";
import TermsAndConditions from "./pages/termsAndConditions";
import CookiesPolicyPage from "./pages/cookiesPolicyPage";
import PrivacyPolicyPage from "./pages/privacyPolicyPage";
import QualityControlAndShipmentPhotography from "./pages/qualityPage";
import ShippingInsurance from "./pages/shippingInsurancePage";
import OurServicesPage from "./pages/ourServicesPage";
import ContactUsPage from "./pages/contactUsPage";
import LoginPage from "./pages/loginPage";
import RegistrationPage from "./pages/registerationPage";
import ForgetPasswordPage from "./pages/forgetPasswordPage";
import ResetPasswordPage from "./pages/resestPasswordPage";
import AccountUser from "./pages/accountUser";
import OTPPage from "./pages/otpPage";
import NewStores from "./pages/NewStores";
import Dashboard from "./pages/Dashboard";
import PackagingShipmentsBeforeShippingPage from "./pages/PackagingShipmentsBeforeShippingPage";
import LoadingPage from "./component/animation/LoadingPage";
import "./App.css";
import AccountInfoSection from "./component/accountUser/accountInfoSection";
import BoxSection from "./component/controlAccount/boxSection";
import CartChooseButton from "./component/cartAddress/customButtonChooseCart";
import ListOfBoxCardOrders from "./component/boxDetials/listOfBoxOrdersCart";
import ImportantAdver from "./component/controlAccount/importantAdver";
import FinishedOrders from "./component/finishedOrders/finishedOrdersSection";
import CustomOrders from "./component/myOrders/CustomOrder";
import ItemsBuyMeSection from "./component/buyForMe/ItemsBuyMeSection/itemsSection";
import DashboardLearning from "./pages/dashboardLearning";
import NotFoundPage from "./pages/NotFoundPage";
import { useDispatch, useSelector } from "react-redux";
import { getAddressesByUserId } from "./redux/reducer/userAddressReducer";
import StickyCard from "./component/home/StickyCard";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthCallback from "./component/auth/AuthCallback";
import { Testimonials } from "./component/testimonials/testimonials";
const LanguageRouter = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { addresses } = useSelector((state) => state.userAddress);
  const accessToken = localStorage.getItem("accessToken");
  const [direction, setDirection] = useState(
    localStorage.getItem("language") === "ar" ? "ltr" : "rtl"
  );
  const [isInitialized, setIsInitialized] = useState(false);
  const isFirstRun = React.useRef(true);
  const hasNavigated = React.useRef(false);

  const storedLang = localStorage.getItem("language");
  const urlLang = lang && ["ar", "en"].includes(lang) ? lang : "ar";

  useEffect(() => {
    const fetchAddresses = async () => {
      if (accessToken) {
        // console.log("HEEEEEEEEEEEEREREREREREREREER");
        setTimeout(() => {
          dispatch(getAddressesByUserId());
        }, 3000);
        // await dispatch(getAddressesByUserId());
      } else {
        setIsInitialized(true);
      }
    };
    fetchAddresses();
  }, [dispatch, accessToken]);

  const handleLoggedInLanguage = () => {
    let preferredLang = addresses?.user?.language || "ar";

    const hasValidLanguage = lang && ["ar", "en"].includes(lang);

    if (!hasValidLanguage) {
      if (!hasNavigated.current) {
        const currentPath = location.pathname.replace(/^\/(ar|en)/, "");
        const newPath = `/${preferredLang}${currentPath}`;
        hasNavigated.current = true;
        sessionStorage.setItem("isLanguageRedirect", "true");
        window.location.replace(newPath);
      }
      return;
    }

    if (lang !== preferredLang) {
      if (!hasNavigated.current) {
        const currentPath = location.pathname.replace(/^\/(ar|en)/, "");
        const newPath = `/${preferredLang}${currentPath}`;
        hasNavigated.current = true;
        sessionStorage.setItem("isLanguageRedirect", "true");
        localStorage.removeItem("language");
        window.location.replace(newPath);
      }
      return;
    }

    localStorage.setItem("language", preferredLang);
    i18n.changeLanguage(preferredLang);

    const direction = preferredLang === "ar" ? "ltr" : "rtl";
    document.documentElement.dir = direction;
    setDirection(direction);
    setIsInitialized(true);
  };

  // Guest
  const handleGuestLanguage = () => {
    let preferredLang = urlLang || "ar";
    const hasValidLanguage = lang && ["ar", "en"].includes(lang);

    if (!hasValidLanguage) {
      if (!hasNavigated.current) {
        const currentPath = location.pathname.replace(/^\/(ar|en)/, "");
        const newPath = `/${preferredLang}${currentPath}`;
        hasNavigated.current = true;
        sessionStorage.setItem("isLanguageRedirect", "true");
        localStorage.setItem("language", preferredLang);
        window.location.replace(newPath);
      }
      return;
    }
    localStorage.setItem("language", preferredLang);
    i18n.changeLanguage(preferredLang);

    const direction = urlLang === "ar" ? "ltr" : "rtl";
    document.documentElement.dir = direction;
    setDirection(direction);
    setIsInitialized(true);
  };

  useEffect(() => {
    if (sessionStorage.getItem("isLanguageRedirect") === "true") {
      sessionStorage.removeItem("isLanguageRedirect");
      return;
    }

    if (urlLang && storedLang && urlLang !== storedLang && accessToken) {
      const currentPath = location.pathname.replace(/^\/(ar|en)/, "");
      const newPath = `/${storedLang}${currentPath}`;
      sessionStorage.setItem("isLanguageRedirect", "true");
      window.location.replace(newPath);

      return;
    }

    if (sessionStorage.getItem("isLanguageSwitching") === "true") {
      sessionStorage.removeItem("isLanguageSwitching");
      return;
    }

    if (accessToken && !addresses?.user) return;

    if (accessToken) {
      handleLoggedInLanguage();
    } else {
      handleGuestLanguage();
    }

    isFirstRun.current = false;
  }, [lang, accessToken, addresses?.user]);

  if (!isInitialized) {
    return <LoadingPage />;
  }

  return children;
};

const ResetScroll = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(
    localStorage.getItem("language") === "ar" ? "rtl" : "ltr"
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setDirection(localStorage.getItem("language") === "ar" ? "rtl" : "ltr");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const language = localStorage.getItem("language");
    setDirection(language === "ar" ? "rtl" : "ltr");
  }, [localStorage.getItem("language")]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return children;
};

const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [location]);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [location]);

  useEffect(() => {
    const img = new Image();
    img.src = main;
    img.onload = () => setBgLoaded(true);
  }, []);

  const AppRoutes = () => (
    <>
      <Routes>
        {/* ------------------ Tracks without language ------------------ */}
        <Route path="/" element={<HomeUser />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/explain-buy" element={<ExplainBuyPage />} />
        <Route path="/shop-and-ship" element={<CountShippingPage />} />
        <Route path="/category-turkey" element={<ChooseCategoryTrukeyPage />} />
        <Route path="/category-europe" element={<ChooseCategoryEroupaPage />} />
        <Route
          path="/category-europe/:name"
          element={<ChooseShoppingEroupaPage />}
        />
        <Route
          path="/category-turkey/:name"
          element={<ChooseShoppingTrukeyPage />}
        />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route
          path="/quality-control-and-shipment-photography"
          element={<QualityControlAndShipmentPhotography />}
        />
        <Route
          path="/packaging-and-shipments"
          element={<PackagingShipmentsBeforeShippingPage />}
        />
        <Route path="/shipping-insurance" element={<ShippingInsurance />} />
        <Route path="/our-services" element={<OurServicesPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/otp" element={<OTPPage />} />
        <Route path="/stores/:name" element={<NewStores />} />
        <Route path="/dashboard-learning" element={<DashboardLearning />} />

        {/* AccountAdmin routes */}
        <Route path="/Dashboard" element={<Dashboard />}>
          <Route path="orders-placed" />
          <Route path="priced-orders" />
          <Route path="purchased-orders" />
          <Route path="incoming-orders" />
          <Route path="received-orders" />
          <Route path="packed-orders" />
          <Route path="shipped-orders" />
          <Route path="delivered-orders" />
        </Route>

        {/* AccountUser routes */}
        <Route path="/my-account" element={<AccountUser />}>
          <Route path="info" element={<AccountInfoSection />} />
          <Route path="dashboard" element={<BoxSection />} />
          <Route path="box-address" element={<CartChooseButton />} />
          <Route path="buy-for-me" element={<ItemsBuyMeSection />} />
          <Route path="my-orders" element={<ListOfBoxCardOrders />} />
          <Route path="your-box-contents" element={<ImportantAdver />} />
          <Route path="finished-orders" element={<FinishedOrders />} />
          <Route path="my-shipments" element={<CustomOrders />} />
        </Route>

        {/* ------------------ Same paths but with :lang ------------------ */}
        <Route path="/:lang">
          <Route index element={<HomeUser />} />
          <Route path="explain-buy" element={<ExplainBuyPage />} />
          <Route path="count-shipping" element={<CountShippingPage />} />
          <Route
            path="category-turkey"
            element={<ChooseCategoryTrukeyPage />}
          />
          <Route
            path="category-europe"
            element={<ChooseCategoryEroupaPage />}
          />
          <Route
            path="category-europe/:name"
            element={<ChooseShoppingEroupaPage />}
          />
          <Route
            path="category-turkey/:name"
            element={<ChooseShoppingTrukeyPage />}
          />
          <Route path="terms-conditions" element={<TermsAndConditions />} />
          <Route path="cookies-policy" element={<CookiesPolicyPage />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="quality-control-and-shipment-photography"
            element={<QualityControlAndShipmentPhotography />}
          />
          <Route
            path="packaging-and-shipments"
            element={<PackagingShipmentsBeforeShippingPage />}
          />
          <Route path="shipping-insurance" element={<ShippingInsurance />} />
          <Route path="our-services" element={<OurServicesPage />} />
          <Route path="contact-us" element={<ContactUsPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="registration" element={<RegistrationPage />} />
          <Route path="forget-password" element={<ForgetPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="otp" element={<OTPPage />} />
          <Route path="stores/:name" element={<NewStores />} />
          <Route path="dashboard-learning" element={<DashboardLearning />} />

          {/* AccountAdmin routes */}
          <Route path="Dashboard" element={<Dashboard />}>
            <Route path="orders-placed" />
            <Route path="priced-orders" />
            <Route path="purchased-orders" />
            <Route path="incoming-orders" />
            <Route path="received-orders" />
            <Route path="packed-orders" />
            <Route path="shipped-orders" />
            <Route path="delivered-orders" />
          </Route>

          {/* AccountUser routes */}
          <Route path="my-account" element={<AccountUser />}>
            <Route path="info" element={<AccountInfoSection />} />
            <Route path="dashboard" element={<BoxSection />} />
            <Route path="box-address" element={<CartChooseButton />} />
            <Route path="buy-for-me" element={<ItemsBuyMeSection />} />
            <Route path="my-orders" element={<ListOfBoxCardOrders />} />
            <Route path="your-box-contents" element={<ImportantAdver />} />
            <Route path="finished-orders" element={<FinishedOrders />} />
            <Route path="my-shipments" element={<CustomOrders />} />
          </Route>
        </Route>

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      /> */}
    </>
  );

  return (
    <div className="relative min-h-screen bg-yellow-50">
      <div
        className="absolute inset-0 z-0 w-full h-full transition-opacity duration-500"
        style={{
          backgroundImage: bgLoaded ? `url(${main})` : "none",
          backgroundRepeat: "repeat",
          width: "auto",
          height: "auto",
          backgroundPosition: "center",
          opacity: bgLoaded ? 0.03 : 0,
        }}
      />
      {!bgLoaded && (
        <div className="absolute inset-0 z-0 w-full h-full bg-gray-100 animate-pulse" />
      )}
      <div className="relative z-10">
        <AuthProvider>
          <ResetScroll>
            {loading && <LoadingPage />}
            <Routes>
              <Route
                path="/:lang/*"
                element={
                  <LanguageRouter>
                    <AppRoutes />
                  </LanguageRouter>
                }
              />

              <Route
                path="*"
                element={
                  <LanguageRouter>
                    <AppRoutes />
                  </LanguageRouter>
                }
              />
            </Routes>

            {/* {addresses?.user?.role !== "admin" && ( */}
            <StickyCard
              isLoggedIn={false}
              onLoginClick={() => alert("Login clicked")}
              onSignupClick={() => alert("Signup clicked")}
            />
            {/* )} */}
          </ResetScroll>
        </AuthProvider>
      </div>
    </div>
  );
};

export default App;
